import * as React from "react";
import Box from "@sproutsocial/seeds-react-box";
import Skeleton from "@sproutsocial/seeds-react-skeleton";
import type { TypeDataItemSkeletonProps } from "./DataItemSkeletonTypes";

const DataItemSkeleton = ({
  hasIcon = false,
  hasAside = false,
  hasSubtext = false,
}: TypeDataItemSkeletonProps) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      borderRadius="outer"
      alignItems="flex-start"
      mb={100}
    >
      <Box display="flex" flex="1">
        {hasIcon && (
          <Box mr={300} flexShrink={0}>
            <Skeleton width={21} height={21} borderRadius="pill" />
          </Box>
        )}
        <Box flex="1">
          <Skeleton width="80%" height={21} borderRadius="inner" />
          {hasSubtext && (
            <Skeleton width="60%" height={16} mt={300} borderRadius="inner" />
          )}
        </Box>
      </Box>
      {hasAside && (
        <Box display="flex" alignItems="center" gap={300} flexShrink={0}>
          <Skeleton width={60} height={21} borderRadius="inner" />
        </Box>
      )}
    </Box>
  );
};

DataItemSkeleton.displayName = "DataItemSkeleton";

export default DataItemSkeleton;
